/** 시작 화면은 최대 2초. 그 뒤에는 메인을 먼저 열고 로그인은 뒤에서 끝낸다. */
export const SPLASH_MAX_MS = 2000;

export function hasStoredPiSession(storage) {
  if (!storage) return false;
  try {
    return storage.getItem('user-type') === 'pi' && !!storage.getItem('pi-user-id');
  } catch (e) {
    return false;
  }
}

/**
 * hadSession: 이번 실행을 시작했을 때 이미 세션이 있었는지.
 * 방금 로그인이 끝나 세션이 생긴 경우와 구분한다.
 */
export function getBootView({ elapsedMs, authState, hadSession, mapReady }) {
  if (hadSession || elapsedMs >= SPLASH_MAX_MS) {
    return { showSplash: false, bootCover: false };
  }
  if (authState === 'initializing') {
    return { showSplash: true, bootCover: false };
  }
  if (authState === 'guest') {
    return { showSplash: false, bootCover: false };
  }
  if (!mapReady) {
    return { showSplash: false, bootCover: true };
  }
  return { showSplash: false, bootCover: false };
}

/** 결제·지급은 서버 확인이 끝난 계정만. 게스트와 로그인 중에는 열지 않는다. */
export function canOpenSensitiveAction(authState) {
  return authState === 'authenticated';
}
